module.exports = __webpack_public_path__ + "static/media/PC3.6f82a704.png";